<template>
  <div>
    <slot />
  </div>
</template>

<script>
import createProvider from './create-provider';
import { video } from './prop-definitions';

export default {
  ...createProvider('refapp-video-provider', video),
};
</script>
